module.exports = __webpack_public_path__ + "img/info01.17d6de6a.png";